const DealPDFViewer = () => {
    return(
        <div>
            a sdf asdf asdf assdfasdfasdf asdf asd fasd fasd fasddf asdf asdf sad
        </div>
    );
}

export default DealPDFViewer;